import StudyTimeChart from "./study-time-chart"
import type { Course } from "@/modules/courses/entities/courses"

interface StudyTimeProps {
  activeCourses: Course[]
}

export default function StudyTime({ activeCourses }: StudyTimeProps) {
  return (
    <div className="mb-2 flex w-full">
      <StudyTimeChart courses={activeCourses} />
    </div>
  )
}
